<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">选择物品</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-table class="table" size="mini" :data="tableData" height="300" border v-loading="loading">
          <el-table-column prop="name" label="物品名称"></el-table-column>
          <el-table-column prop="supplierName" label="供应商"></el-table-column>
          <el-table-column prop="waresTypeName" label="物品类型"></el-table-column>
          <el-table-column prop="stock" label="库存"></el-table-column>
          <el-table-column prop="unit" label="单位"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="handleSelect(scope.$index, scope.row)">选择</el-button>
            </template>
          </el-table-column>

        </el-table>

        <div class="page" style="padding: 5px">
          <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination small
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="20"
                @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode,getTokenBykey} from "@/utils/auth";

export default {
  name: "Add",
  data() {
    return {

      loading: true,


      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      th:0,

      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        name:'',
      },

      rules:{
        name:[
          { required: true, message: '物品名称', trigger: 'blur' },
        ],
        sort:[
          { required: true, message: '请输入库存', trigger: 'blur' },
          { type: 'number', message: '库存必须为数字值'}
        ],
      }


    }
  },

  methods: {
    init(){
      this.getList();

    },
    closeSelf() {
      this.$emit("closeWares");
    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      this.loading=true;

      var supplierCode=this.supplierCode;
      var waresTypeCode=this.waresTypeCode;
      var warehouseCode=this.warehouseCode;
      if(!supplierCode){
        supplierCode='00000000-0000-0000-0000-000000000000'
      }
      if(!waresTypeCode){
        waresTypeCode='00000000-0000-0000-0000-000000000000'
      }
      if(!warehouseCode){
        warehouseCode='00000000-0000-0000-0000-000000000000'
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Wares/Page',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,

          waresTypeCode:waresTypeCode,
          supplierCode:supplierCode,
          warehouseCode:warehouseCode,
          name:'',
          status:-1,

        }
      }).then((response)=> {
        this.loading=false;

        if(response.data.error == 0){
          //var data= response.data.data.list;
          this.tableData=response.data.data.list;//this.getData(data)
          this.totalItems = response.data.data.total;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    handleSelect(index,row){
      this.$emit("setWares",row);
      this.$emit("closeWares");
    },


    statusTitle(row){
      if(row.status == 0){
        return "正常";
      }
      if(row.status == 1){
        return "禁用";
      }
      return "其它";
    },



    handleSelect2(index,row){
      var list=getTokenBykey(getStaffCode()+'waresInfoAdd');
      list?list=JSON.parse(list):list=[]

      if(this.isAdd(row.waresCode,list)){

        this.$prompt('请输入此物品入库数量', '添加商品数量', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern:/^[1-9]\d*$/,
          inputErrorMessage:'添加数量不能为零',
          inputType:'number'
        }).then(({ value }) => {
          row.count=value
          this.$emit("getWares",row);
          this.tableData=this.getData(this.tableData)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });

      }
      else{
        this.$message({
          type: 'info',
          message: '此物品已添加'
        });
      }

    },
    isAdd(code,list){
      for(var i in list){
        if(list[i].waresCode==code){
          return false;
        }
      }
      return true
    },

    getData(data){
      var waresInfoAdd=getTokenBykey(getStaffCode()+'waresInfoAdd');
      for(var i in data){
        if(waresInfoAdd){
          if(!this.isAdd(data[i].waresCode,JSON.parse(waresInfoAdd))){
            data[i].add=1
          }else{
            data[i].add=0
          }
        }else{
          data[i].add=0
        }
      }
      console.log(data)
      return data
    }


  }
}
</script>

<style  lang="scss" scoped>

</style>
